import {AbstractControl, Validators} from '@angular/forms';
import {MonoTypeOperatorFunction} from 'rxjs';

/**
 * Makes {@code target} required only while {@code trigger} holds a value, so the "required" warning does not show when
 * the target is touched before anything is selected.
 *
 * @param {AbstractControl} trigger - the control whose selection switches the rule on and off
 * @param {AbstractControl} target - the control that becomes required while the trigger has a value
 * @param {MonoTypeOperatorFunction<unknown>} teardown - the caller's unsubscribe operator, tied to its lifecycle
 */
export function requireWhileSelected(
    trigger: AbstractControl,
    target: AbstractControl,
    teardown: MonoTypeOperatorFunction<unknown>): void
{
    trigger.valueChanges.pipe(teardown).subscribe(value =>
    {
        if (value)
        {
            target.addValidators(Validators.required);
        }
        else
        {
            target.removeValidators(Validators.required);
        }
        target.updateValueAndValidity({emitEvent: false});
    });
}
